import {StepDataAnswer} from "components/chart/StepDataAnswer";
import * as moment from "moment";

export class StepData {
  step;
  answers;

  constructor(step, feedItems) {
    this.step = step;
    this.answers = [];
    // extract the answers
    for (let i = 0; i < feedItems.length; i++) {
      if (feedItems[i].data) {
        for (let j = 0; j < feedItems[i].data.length; j++) {
          if (feedItems[i].data[j].stepId == step._id) {
            try {
              let answerValue = feedItems[i].data[j].answerValue;
              answerValue++;
              this.answers.push(new StepDataAnswer(answerValue, moment(feedItems[i].displayDate)));
            } catch(e) {
              console.log('answer must be an integer');
              console.log(e);
            }
            break;
          }
        }
      }
    }
    // sort the answers
    this.answers.sort(function (a, b) {
      return a.date.diff(b.date);
    });
  }

  xyData() {
    const xy: Array<any> = [];
    for (let i = 0; i < this.answers.length; i++) {
      xy.push({x: this.answers[i].date, y: this.answers[i].answer});
    }
    return xy;
  }

}
